import React from 'react';
import Popup from '@kibt/meta-ui-krn/lib/components/Popup';
import { AddOnHelper } from './addOnHelper';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { KView } from '@/component/RtlLayout';
import { TouchableWithoutFeedback } from 'react-native';
import { isWeb } from '@/common/device-info';

export interface AddOnHelperPopupProps {
    visible: boolean;
    onClose: () => void;
    addonQuery: {
        photoId: string | number;
        authorId: string | number;
        couponBatchId: string | number;
        itemId: string | number;
        merchantId: string | number;
    };
    pageStatus: string; // 半屏/全屏
    pageHeight: number;
    isFromDetail?: boolean; // 是否来自商详
    targetMakeupCoupon?: any; // 目标凑单券
}

const AddOnHelperPopup: React.FC<AddOnHelperPopupProps> = (props) => {
    const { visible, onClose, addonQuery, pageStatus, pageHeight, isFromDetail, targetMakeupCoupon } = props;
    return (
        <Popup lockScroll={true} visible={visible} duration={150} onClose={onClose} position="bottom">
            <SafeAreaProvider>
                {!isWeb ? (
                    <TouchableWithoutFeedback onPress={onClose}>
                        <KView style={{ height: '100%' }} />
                    </TouchableWithoutFeedback>
                ) : null}
                <AddOnHelper
                    targetMakeupCoupon={targetMakeupCoupon}
                    isFromDetail={isFromDetail}
                    pageStatus={pageStatus}
                    pageHeight={pageHeight}
                    popupProps={{ isPopup: true, onClose, source: 'recommendGoods', addonQuery }}
                />
            </SafeAreaProvider>
        </Popup>
    );
};

export default AddOnHelperPopup;
